export default __webpack_public_path__ + "static/media/DownloadJson.bb7abfc3.svg";